
    import { Options, Vue } from 'vue-class-component';
    import axios from 'axios'
    import _ from 'lodash'

    @Options({
        components: {},
    
    })
    export default class Geomap extends Vue {
        
        public time:any = ""
        public timePeriod = ""
        public apiKey = "9377b6126def15ad0a8ce82d320cc208"
        public latitude = 0
        public longitude = 0
        public temperature = 0
        public weatherStatus = ""

        mounted() {
                
            if (navigator.geolocation) {
            navigator.geolocation.watchPosition(position => {
                this.latitude = position.coords.latitude
                this.longitude = position.coords.longitude

                    axios
                        .get("https://api.openweathermap.org/data/2.5/weather?lat="+this.latitude+"&lon="+this.longitude+"&appid="+this.apiKey)      
                        .then(response => { 
                            let temp = ((response.data.main.temp) -  273.15);
                            this.temperature = _.round(temp, 1); 
                            this.weatherStatus = response.data.weather[0].description;
                        }) 
                });
            }

            
        }

        created() {     
        
            setInterval( () => {
                let date = new Date();
            
                let hours = date.getHours();
                let minutes:any = date.getMinutes();
                let seconds:any = date.getSeconds();
                let ampm = hours >= 12 ? 'pm' : 'am';

                hours = hours % 12;
                hours = hours ? hours : 12; 
                minutes = minutes < 10 ? '0' + minutes : minutes;
                seconds = seconds < 10 ? '0' + seconds : seconds;
                let strTime:any = hours + ' : ' + minutes + ' : ' + seconds + ' ';

                this.time = strTime
                this.timePeriod = ampm  
                
            }, 1000)

        }
    }
